
<button type="button" *ngIf="this.orderData && this.orderData.isFavorite" [disabled]="isDisabled" class="favorite-order-cell-button datacenter-total-hidden" mat-icon-button
	color="primary" (click)="deleteFavoriteOrder()">
	<mat-icon svgIcon="md:star"></mat-icon>
</button>

<button type="button" *ngIf="!this.orderData || !this.orderData.isFavorite" [disabled]="isDisabled" class="favorite-order-cell-button datacenter-total-hidden"
	mat-icon-button color="primary" (click)="saveFavoriteOrder()">
	<mat-icon svgIcon="md:star_border"></mat-icon>
</button>
